import z from "zod";

export function sizeAttributeSchema<const Preset extends string>(
  presets: readonly [Preset, ...Preset[]],
) {
  return z
    .enum(presets)
    .or(
      z
        .string()
        .regex(/^\d+(\.\d+)?$/)
        .transform(Number),
    )
    .or(z.string());
}
